import { render, staticRenderFns } from "./QuestionFormActionDialog.vue?vue&type=template&id=c3a8c2b0&scoped=true"
import script from "./QuestionFormActionDialog.vue?vue&type=script&lang=js"
export * from "./QuestionFormActionDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionFormActionDialog.vue?vue&type=style&index=0&id=c3a8c2b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a8c2b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a8c2b0')) {
      api.createRecord('c3a8c2b0', component.options)
    } else {
      api.reload('c3a8c2b0', component.options)
    }
    module.hot.accept("./QuestionFormActionDialog.vue?vue&type=template&id=c3a8c2b0&scoped=true", function () {
      api.rerender('c3a8c2b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionFormActionDialog.vue"
export default component.exports